var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{staticClass:"lg:max-w-4xl",attrs:{"head":"customer_details","hasBack":true,"size":"lg"}},[_c('base-loader',{attrs:{"fetching":_vm.pendingComponentInit}}),(!_vm.pendingComponentInit)?_c('company-form',{attrs:{"mode":'create'},on:{"created":_vm.onClose,"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }